import { AxiosRequestConfig, AxiosResponse } from 'axios'
import { formatISO } from 'date-fns'
import HttpClient from '../http-client'
import { httpConfig } from '../constants'
import { ConciseReport, Report } from '../model/models'

export class ReportAPI extends HttpClient {
  public constructor(apiConfig: AxiosRequestConfig) {
    super(apiConfig)
    this.getReports = this.getReports.bind(this)
    this.getReport = this.getReport.bind(this)
    this.updateReport = this.updateReport.bind(this)
  }

  public getReports(): Promise<ConciseReport[]> {
    return this.get<ConciseReport[]>('/reports')
      .then((response: AxiosResponse<ConciseReport[]>) => response.data)
      .catch((error) => {
        throw error
      })
  }

  public getReport(reportId: number): Promise<Report> {
    return this.get<Report>(`/report/${reportId}`)
      .then((response: AxiosResponse<Report>) => response.data)
      .catch((error) => {
        throw error
      })
  }

  public updateReport(report: Report): Promise<number> {
    return this.post(`/report/${report.id}`, { report })
      .then((response: AxiosResponse) => response.status)
      .catch((error) => {
        throw error
      })
  }

  public deleteReport(reportId: number): Promise<number> {
    return this.delete(`/report/${reportId}`)
      .then((response: AxiosResponse) => response.status)
      .catch((error) => {
        throw error
      })
  }

  public cloneReport(reportId: number): Promise<number> {
    return this.get(`/report/clone/${reportId}`)
      .then((response: AxiosResponse) => response.status)
      .catch((error) => {
        throw error
      })
  }

  public lockReport(reportId: number, lockStatus: boolean): Promise<number> {
    return this.post(`/report/lock/${reportId}`, { lock: lockStatus })
      .then((response: AxiosResponse) => response.status)
      .catch((error) => {
        throw error
      })
  }

  public renameReport(reportId: number, name: string): Promise<number> {
    return this.post(`/report/name/${reportId}`, { name })
      .then((response: AxiosResponse) => response.status)
      .catch((error) => {
        throw error
      })
  }

  public generateReport(
    reportModule: string,
    reportType: string,
    reportTheme: any,
    reportYear: Date,
    reportPeriod: string,
    reportLocale: string,
  ): Promise<number> {
    const endpoint = `/report/create`
    return this.post(endpoint, {
      reportModule,
      reportType,
      reportTheme,
      reportYear: formatISO(reportYear),
      reportPeriod,
      reportLocale,
    })
      .then((response: AxiosResponse) => response.status)
      .catch((error) => {
        throw error
      })
  }

  public getReportPDF(id: number): Promise<Record<string, string>> {
    const endpoint = `/report/pdf/${id}`
    return this.get(endpoint)
      .then((response: AxiosResponse) => response.data)
      .catch((error) => {
        throw error
      })
  }
}

export const reportAPI = new ReportAPI(httpConfig)
